import { jsx as e } from "react/jsx-runtime";
function l({
  children: o,
  className: r
}) {
  return /* @__PURE__ */ e("div", { className: r || "Placeholder__root", children: o });
}
export {
  l as P
};
//# sourceMappingURL=Placeholder-p4UWlP66.js.map
